/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";

import StyledSelect from "./StyledSelect";
import StyledFormControl from "../common/StyledFormControl";

const Select = ({
  handleChange,
  selectedValue,
  label,
  focusedLabel,
  disabled,
  inputId,
  width,
  nullTitle,
  options,
  error,
  dataTestId = "",
}) => {
  const getLabel = () => {
    if (selectedValue != null) {
      return focusedLabel ? focusedLabel : label;
    }
    return label;
  };

  return (
    <StyledFormControl
      variant="outlined"
      style={width ? { width } : {}}
      fullWidth={!width}
      error={error}
    >
      <InputLabel
        id={`${inputId}-label`}
        shrink={selectedValue != null}
        style={{
          fontWeight: selectedValue != null ? 500 : 400,
        }}
      >
        {getLabel()}
      </InputLabel>
      <StyledSelect
        onChange={handleChange}
        value={selectedValue ? selectedValue : ""}
        labelId={`${inputId}-label`}
        disabled={disabled}
        label={getLabel()}
        error={error}
        notched={selectedValue != null}
        data-testid={dataTestId}
        MenuProps={{ classes: { paper: "limit-popover-height" } }}
      >
        {nullTitle && <MenuItem value={null}>{nullTitle}</MenuItem>}
        {options.map((val) => (
          <MenuItem key={val.id} value={val.id}>
            {val.title}
          </MenuItem>
        ))}
      </StyledSelect>
    </StyledFormControl>
  );
};

export default Select;
